import { useMemo } from 'react'

import { PaySystem, useInvoicePaymentMethods } from '@/api/models/finance'

import { PayMethods } from '../BillsPayDrawer.types'

type Props = {
  invoiceId?: string
  isCommonPayment?: boolean
}

export const useBillsPaymentMethods = ({
  invoiceId,
  isCommonPayment
}: Props) => {
  const {
    data: paymentMethods,
    isLoading,
    ...rest
  } = useInvoicePaymentMethods({
    invoiceId
  })

  const options = useMemo(() => {
    if (isLoading) {
      return []
    }

    const result = [...(paymentMethods?.acquiring?.cards || [])]

    if (paymentMethods?.acquiring?.isPermitted) {
      result.push({ id: PayMethods.Acquiring, paySystem: PaySystem.Acquiring })
    }

    if (paymentMethods?.qr?.isPermitted && !isCommonPayment) {
      result.push({ id: PayMethods.Qr, paySystem: PaySystem.Qr })
    }

    return result
  }, [
    isLoading,
    paymentMethods?.acquiring?.cards,
    paymentMethods?.acquiring?.isPermitted,
    paymentMethods?.qr?.isPermitted,
    isCommonPayment
  ])

  return {
    paymentMethods,
    payMethodRadioOptions: options,
    isLoading,
    ...rest
  }
}
